import type { BridgeTimingMode, DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';

export type TurboVehicleColor = 'coral' | 'azure' | 'lime';

export type TurboDuelChoice = {
  id: string;
  label: string;
  correct: boolean;
  mediaUrl?: string;
};

export type TurboDuelQuestion = {
  id: number;
  questionId: string;
  prompt: string;
  promptMediaUrl?: string;
  timeLimitSeconds: number | null;
  choices: TurboDuelChoice[];
};

export type TurboDuelConfig = {
  id: string;
  timingMode: BridgeTimingMode;
  questions: TurboDuelQuestion[];
};

type RaceSource = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions' | 'timingMode'>;

function toQuestion(question: DraftQuestion, level: number, timingMode: BridgeTimingMode): TurboDuelQuestion {
  return {
    id: level,
    questionId: question.id,
    prompt: question.prompt,
    promptMediaUrl: question.media?.url,
    timeLimitSeconds: timingMode === 'per-question' ? question.timeLimitSeconds ?? 30 : null,
    choices: question.choices.map((choice) => ({
      id: choice.id,
      label: choice.text,
      correct: choice.isCorrect,
      mediaUrl: choice.media?.url,
    })),
  };
}

export function draftToTurboDuelConfig(source: RaceSource): TurboDuelConfig {
  const timingMode = source.timingMode ?? 'none';
  const questions = Array.from({ length: source.maxLevels }, (_, index) => {
    const level = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === level);
    if (!question) throw new Error(`${level}. Turbo Düellosu sorusu bulunamadı.`);
    return toQuestion(question, level, timingMode);
  });
  return { id: source.id, timingMode, questions };
}
